import { mergeAttributes, Node } from "@tiptap/core"

const CSS_COLOR_PATTERN = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\([^;]+\)|[a-z]+)$/i

const normalizeCssColor = (value: unknown) => {
  const color = String(value || "").trim()
  return color && CSS_COLOR_PATTERN.test(color) ? color : null
}

/** Preserves framed information/note blocks copied from external pages. */
export const Callout = Node.create({
  name: "callout",
  group: "block",
  content: "block+",
  defining: true,

  addAttributes() {
    return {
      backgroundColor: {
        default: null,
        parseHTML: (element) => normalizeCssColor(element.style.backgroundColor),
        renderHTML: ({ backgroundColor }) => {
          const color = normalizeCssColor(backgroundColor)
          return color ? { style: `background-color: ${color}` } : {}
        },
      },
      borderColor: {
        default: null,
        parseHTML: (element) => normalizeCssColor(element.style.borderColor),
        renderHTML: ({ borderColor }) => {
          const color = normalizeCssColor(borderColor)
          return color ? { style: `border-color: ${color}` } : {}
        },
      },
    }
  },

  parseHTML() {
    return [
      { tag: "div[data-type='callout']" },
      { tag: "div.intercom-interblocks-callout" },
      { tag: "div[style*='background-color'][style*='border-color']" },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(
        { "data-type": "callout", class: "simple-editor-callout" },
        HTMLAttributes,
      ),
      0,
    ]
  },
})
